<ng-container [formGroup]="filterForm">
  <q9-grid-filter-operator-select
    formControlName="operator"
    [operators]="operators"></q9-grid-filter-operator-select>

  <mat-form-field floatLabel="always">
    <mat-label>{{ 'CORE.GRID.VALUE_LABEL' | translate }}</mat-label>

    <input
      q9Trim
      matInput
      type="text"
      [matAutocomplete]="auto"
      [placeholder]="'CORE.ATTACHMENTS.ASSIGNEE_PLACEHOLDER' | translate"
      formControlName="value" />

    <mat-spinner matSuffix *ngIf="isLoading()"></mat-spinner>

    <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="formatAssignee">
      <mat-option
        *ngFor="let option of options()"
        (click)="$event.stopPropagation()"
        [value]="option">
        <q9-user-info [user]="option"></q9-user-info>
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
</ng-container>
